import { useEffect, useState } from "react";
import { api, errorMessage } from "../lib/api";

export const CatalogPicker = ({ value, onChange, testId = "catalog-picker" }) => {
  const [items, setItems] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => { api.get("/catalog").then(({ data }) => setItems(data.items))
    .catch((err) => setError(errorMessage(err))); }, []);
  const setQuantity = (id, quantity) => onChange(quantity > 0
    ? [...value.filter((entry) => entry.id !== id), { id, quantity }]
    : value.filter((entry) => entry.id !== id));
  const price = (item) => item.price_cents === null || item.price_cents === undefined
    ? "Prezzo da configurare" : `${(item.price_cents / 100).toLocaleString("it-IT", { minimumFractionDigits: 2 })} €/mese`;
  return <div className="catalog-picker" data-testid={testId}>
    <span className="section-label">INTERESSI</span>
    {error && <p role="alert" className="form-error" data-testid={`${testId}-error`}>{error}</p>}
    {items.filter((item) => item.active).map((item) => {
      const quantity = value.find((entry) => entry.id === item.id)?.quantity || 0;
      return <div className="catalog-pick-row" key={item.id} data-testid={`${testId}-${item.id}`}>
        <div><strong>{item.name}</strong><small>{item.description ? `${item.description} · ` : ""}{price(item)}</small></div>
        {item.kind === "module" ? <input type="checkbox" checked={quantity > 0}
          onChange={(event) => setQuantity(item.id, event.target.checked ? 1 : 0)}
          aria-label={item.name} data-testid={`${testId}-check-${item.id}`} />
          : <div className="catalog-quantity"><button type="button" aria-label={`Riduci ${item.name}`}
              disabled={quantity === 0} onClick={() => setQuantity(item.id, quantity - 1)}
              data-testid={`${testId}-minus-${item.id}`}>−</button>
            <span data-testid={`${testId}-quantity-${item.id}`}>{quantity}</span>
            <button type="button" aria-label={`Aumenta ${item.name}`} disabled={quantity >= 100}
              onClick={() => setQuantity(item.id, quantity + 1)} data-testid={`${testId}-plus-${item.id}`}>+</button></div>}
      </div>;
    })}
  </div>;
};